import { Subject } from 'rxjs'
import apiResponse from '../../../../../services/apiResponse'
import JenisJabatanRepository from '../Repositories/JenisJabatanRepository'

class JenisJabatanBloc
{
    repository = new JenisJabatanRepository()
    jenisJabatanDatatableChannel = new Subject()
    jenisJabatanSubmitChannel = new Subject()

    constructor() {
        this.jenisJabatanDatatableChannel.next({status: apiResponse.INITIAL})
        this.jenisJabatanSubmitChannel.next({status: apiResponse.INITIAL})
    }

    fetchDataTable = async (query, cancelToken) => {
        this.jenisJabatanDatatableChannel.next({status: apiResponse.LOADING})
        await this.repository.fetchDataTable(query, cancelToken).then((result) => {
            this.jenisJabatanDatatableChannel.next({status: apiResponse.COMPLETED, data: result})
        }).catch((error) => {
            this.jenisJabatanDatatableChannel.next({status: apiResponse.ERROR, data: error})
        })
    }

    fetchSubmit = async (query) => {
        this.jenisJabatanSubmitChannel.next({status: apiResponse.LOADING})
        await this.repository.fetchSubmit(query).then((result) => {
            this.jenisJabatanSubmitChannel.next({status: apiResponse.COMPLETED, data: result})
        }).catch((error) => {
            this.jenisJabatanSubmitChannel.next({status: apiResponse.ERROR, data: error})
        })
    }

}

export default JenisJabatanBloc